/* eslint-disable @typescript-eslint/no-require-imports */
function loadEnv() {
  if (!process.env.NEXT_PUBLIC_SANITY_DATASET) {
    try {
      require('dotenv').config({
        path: require('path').resolve(__dirname, '../../.env.local'),
      });
      console.log('🔧 Loaded env vars manually');
    } catch (err) {
      console.warn('❌ Failed to load dotenv:', err);
    }
  }
}

loadEnv();

// Define types for environment variables
const store = {
  dataset: process.env.NEXT_PUBLIC_SANITY_DATASET || '',
  projectId: process.env.NEXT_PUBLIC_SANITY_PROJECT_ID || '',
  apiVersion: '2023-05-23',
  useCdn: true,
  googleKey: process.env.NEXT_PUBLIC_GOOGLE_KEY,
  token: process.env.NEXT_PUBLIC_SANITY_TOKEN,
  isAdsEnable: false,
  GOOGLE_ADS_ID: process.env.NEXT_PUBLIC_GOOGLE_ADS_ID,
};

export default store;
